<section
  fxLayout="column"
  fxLayoutAlign="center center"
  [ngClass.lt-sm]="{'layout xs sm':true}"
  [ngClass.lt-md]="{'layout sm':true}"
>
  <h2>診療時間案内</h2>
  <div class="diagnosis-days" fxLayout="column" fxLayoutAlign="center start">
    <table>
      <caption>受付時間 9：00 ～ 18：30</caption>
      <thead>
        <tr>
          <th>月</th>
          <th>火</th>
          <th>水</th>
          <th>木</th>
          <th>金</th>
          <th>土</th>
          <th>日・祝</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>◯</td>
          <td>◯</td>
          <td>◯</td>
          <td>◯</td>
          <td>◯</td>
          <td>◯</td>
          <td>ー</td>
        </tr>
      </tbody>
    </table>
    <div class="reserve" fxLayout="row" fxLayoutAlign="center center">
      <span>ご予約、お問い合わせ</span>
      <span class="phone">
        <a href="tel:0173-35-0131" fxLayout="row" fxLayoutAlign="center center">
          <mat-icon fontSet="material-icons-outlined">phone</mat-icon>
          <span>0173-35-0131</span>
        </a>
      </span>
      <span class="hotpepper" fxLayout="row" fxLayoutAlign="center center">
        <a href="https://beauty.hotpepper.jp/kr/slnH000467455/" rel="noopener noreferrer">
          <img src="/assets/img/logo_hotpepper.svg" alt="ホットペッパー 予約">
        </a>
      </span>
    </div>
  </div>
</section>
